/**
 * @desc 根据积加店铺ID获取店铺信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlatformSiteShopResponseDto>;
export function request(
  params: API.basics.platformSiteShopFacadeImpl.getByGjMarketId.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/platformSiteShop/getByGjMarketId`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
